/**
 * Marketing / legal URLs on x9.app — same paths as apps/web-x9.
 * PT locale pages may 404 until marketing ships them; fall back to en.
 */

export const X9_MARKETING_BASE_URL = 'https://x9.app';

export function detectAppLocale(): string {
  if (typeof navigator === 'undefined') return 'en';
  const lang = (navigator.language || 'en').toLowerCase();
  if (lang.startsWith('pt')) return 'pt';
  return 'en';
}

function marketingLocale(appLocale: string): string {
  // Live site currently serves /en/legal/*; keep pt-br path for when marketing ships it.
  if (appLocale === 'pt' || appLocale === 'pt-BR' || appLocale === 'pt-br') return 'pt-br';
  return 'en';
}

export function getTermsUrl(appLocale = detectAppLocale()): string {
  const locale = marketingLocale(appLocale);
  // Prefer en until pt-br legal pages are published (pt-br currently 404s).
  const safe = locale === 'pt-br' ? 'en' : locale;
  return `${X9_MARKETING_BASE_URL}/${safe}/legal/terms`;
}

export function getPrivacyUrl(appLocale = detectAppLocale()): string {
  const locale = marketingLocale(appLocale);
  const safe = locale === 'pt-br' ? 'en' : locale;
  return `${X9_MARKETING_BASE_URL}/${safe}/legal/privacy`;
}
